export const tokenNameConfig = {
  default: {
      token: "token",
      refresh_token: "refresh_token",
  },
  additional: {
      token: "additional-form-token",
      refresh_token: "additional-form-refresh-token",
  }
}

export const getTokenNames = (module) => tokenNameConfig[module] || tokenNameConfig.default;
